<template src="./metronome.html" />

<script>
export default {
  name: 'MetronomeApp',

  data() {
    return {

      activeTimer:false,
      timerId:null,

      audio:null,
      audio_second:null,
      gocFirst:null,
      gocSecond:null,
      gocThird:null,
      gocForth:null,
      gocFifth:null,
      audioContext: null,
      nextNoteTime: 0,
      lookahead: 25,
      scheduleAheadTime: 0.1,

      counterBeat:0,

      speed:60,

      typeBeats:'beat',

      measure:'2/4',

      measureItems:[
        '2/4',
        '3/4',
        '7/8 (на прву)',
        '7/8 (на средњу)',
        '7/8 (на трећу)',
        'румба (3 ударца)',
        'румба (4 ударца)',
        '9/8',
        '5/8',
        '11/8 (у средини)',
        '12/8',
        'бегин',
        'ориентал'
      ],

      speedItems:[
        30,35,40,45,50,55,60,65,70,75,80,85,90,95,
        100,105,110,115,120,125,130,135,140,145,150,
        155,160,165,170,175,180,185,190,195,200,
        205,210,215,220,225,230,235,240,245,250,
        255,260,265,270,275,280,285,290,295,300
      ],

      patterns:{
        "2/4":{
          length:4,
          beat:[0,2],
          goc:[
            {i:0,s:"gocFirst"},
            {i:1,s:"gocSecond"},
            {i:2,s:"gocThird"},
            {i:3,s:"gocForth"}
          ]
        },

         "3/4":{
          length:6,
          beat:[0,3],
          goc:[
            {i:0,s:"gocFirst"},
            {i:1,s:"gocSecond"},
            {i:2,s:"gocForth"},
            {i:3,s:"gocFirst"},
            {i:4,s:"gocSecond"},
            {i:5,s:"gocForth"}
          ]
        },

        "7/8 (на прву)":{
          length:7,
          beat:[0,3,5],
          goc:[
            {i:0,s:"gocFirst"},
            {i:2,s:"gocSecond"},
            {i:3,s:"gocFirst"},
            {i:5,s:"gocSecond"}
          ]
        },

        "7/8 (на средњу)":{
          length:7,
          beat:[0,2,5],
          goc:[
            {i:0,s:"gocSecond"},
            {i:2,s:"gocFirst"},
            {i:4,s:"gocSecond"},
            {i:5,s:"gocFirst"}
          ]
        },

        "7/8 (на трећу)":{
          length:7,
          beat:[0,2,4],
          goc:[
            {i:0,s:"gocFirst"},
            {i:2,s:"gocSecond"},
            {i:4,s:"gocFirst"},
            {i:6,s:"gocSecond"}
          ]
        },

        "румба (3 ударца)":{
          length:8,
          beat:[0,3,6],
          goc:[
            {i:0,s:"gocFirst"},
            {i:3,s:"gocSecond"},
            {i:6,s:"gocSecond"}
          ]
        },

        "румба (4 ударца)":{
          length:8,
          beat:[0,3,4,6],
          goc:[
            {i:0,s:"gocFirst"},
            {i:3,s:"gocSecond"},
            {i:4,s:"gocFirst"},
            {i:6,s:"gocSecond"}
          ]
        },

        "9/8":{
          length:9,
          beat:[0,2,4,6],
          goc:[
            {i:0,s:"gocFirst"},
            {i:1,s:"gocSecond"},
            {i:2,s:"gocThird"},
            {i:3,s:"gocForth"},
            {i:4,s:"gocFirst"},
            {i:5,s:"gocSecond"},
            {i:6,s:"gocThird"},
            {i:7,s:"gocForth"},
            {i:8,s:"gocFifth"}
          ]
        },

        "5/8":{
          length:5,
          beat:[0,2],
          goc:[
            {i:0,s:"gocFirst"},
            {i:1,s:"gocSecond"},
            {i:2,s:"gocThird"},
            {i:3,s:"gocForth"},
            {i:4,s:"gocFifth"}
          ]
        },

        "11/8 (у средини)":{
          length:11,
          beat:[0,2,4,7,9],
          goc:[
            {i:0,s:"gocFirst"},
            {i:2,s:"gocSecond"},
            {i:4,s:"gocFirst"},
            {i:6,s:"gocForth"},
            {i:7,s:"gocThird"},
            {i:9,s:"gocForth"}
          ]
        },

        "12/8":{
          length:12,
          beat:[0,2,5,7,9],
          goc:[
            {i:0,s:"gocFirst"},
            {i:1,s:"gocSecond"},
            {i:2,s:"gocThird"},
            {i:3,s:"gocForth"},
            {i:4,s:"gocFifth"},
            {i:5,s:"gocFirst"},
            {i:6,s:"gocSecond"},
            {i:7,s:"gocThird"},
            {i:8,s:"gocForth"},
            {i:9,s:"gocFirst"},
            {i:10,s:"gocSecond"},
            {i:11,s:"gocForth"}
          ]
        },

        "бегин":{
          length:16,
          beat:[0,3,6,8,12],
          goc:[
            {i:0,s:"gocFirst"},
            {i:3,s:"gocSecond"},
            {i:6,s:"gocForth"},
            {i:8,s:"gocFirst"},
            {i:12,s:"gocSecond"}
          ]
        },

        "ориентал":{
          length:16,
          beat:[0,3,6,8,10,12],
          goc:[
            {i:0,s:"gocFirst"},
            {i:3,s:"gocSecond"},
            {i:6,s:"gocForth"},
            {i:8,s:"gocThird"},
            {i:10,s:"gocFifth"},
            {i:12,s:"gocSecond"}
          ]
        }

      }

    }
  },

  mounted(){

    this.audio = new Audio(require('../assets/metronome_tick.mp3'))
    this.audio_second = new Audio(require('../assets/metronome_tick_2.mp3'))

    this.gocFirst = new Audio(require('../assets/goc_first.mp3'))
    this.gocSecond = new Audio(require('../assets/goc_second.mp3'))
    this.gocThird = new Audio(require('../assets/goc_first_2.mp3'))
    this.gocForth = new Audio(require('../assets/goc_second_2.mp3'))
    this.gocFifth = new Audio(require('../assets/goc_second.mp3'))

  },

  methods:{

  playSoundAtTime(sound, time){
    const source = this.audioContext.createBufferSource()
    const gain = this.audioContext.createGain()

    // dekodiraj ako nije već
    if(!sound.buffer){
      fetch(sound.src)
        .then(r => r.arrayBuffer())
        .then(data => this.audioContext.decodeAudioData(data))
        .then(buffer => {
          sound.buffer = buffer
          this.playSoundAtTime(sound, time)
        })
      return
    }

    source.buffer = sound.buffer
    source.connect(gain)
    gain.connect(this.audioContext.destination)

    source.start(time)
  },

  tick(time){
    if(this.counterBeat === 0){
      this.playSoundAtTime(this.audio_second, time)
    }else{
      this.playSoundAtTime(this.audio, time)
    }
  },

  step(time){
    const pattern = this.patterns[this.measure]
    if(!pattern) return

    if(this.typeBeats === "beat"){
      if(pattern.beat.includes(this.counterBeat)){
        this.tick(time)
      }
    }else{
      const g = pattern.goc.find(x => x.i === this.counterBeat)
      if(g){
        this.playSoundAtTime(this[g.s], time)
      }
    }

    this.counterBeat++

    if(this.counterBeat >= pattern.length){
      this.counterBeat = 0
    }
  },

  nextNote(){
    let interval = 120000 / (this.speed * 4)

    if (
      this.measure === '7/8 (на прву)' ||
      this.measure === '7/8 (на средњу)' ||
      this.measure === '7/8 (на трећу)' || 
      this.measure === 'румба (3 ударца)' || 
      this.measure === 'румба (4 ударца)' || 
      this.measure === '11/8 (у средини)' || 
      this.measure === '12/8' || 
      this.measure === 'бегин' || 
      this.measure === 'ориентал' 
    ) {
      interval /= 1.5
    }

    this.nextNoteTime += interval / 1000
  },

  scheduler(){
    while(
      this.nextNoteTime <
      this.audioContext.currentTime + this.scheduleAheadTime
    ){
      this.step(this.nextNoteTime)
      this.nextNote()
    }
  },

  start(){
    if(this.activeTimer) return

    if(!this.audioContext){
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    }

    this.audioContext.resume()

    this.counterBeat = 0
    this.activeTimer = true

    this.nextNoteTime = this.audioContext.currentTime

    this.timerId = setInterval(()=>{
      this.scheduler()
    }, this.lookahead)
  },

  stop(){
    this.activeTimer = false
    clearInterval(this.timerId)
  }

  }
}
</script>

<style scoped>
/* ===== BACKGROUND ===== */
.background {
  background: linear-gradient(rgba(161,71,71,0.92), rgba(161,71,71,0.92)),
              url('../assets/background_sara.png');
  background-size: cover;
  background-position: center;
}

/* ===== CARD ===== */
.v-card {
  border-radius: 20px;
  padding-bottom: 25px;
  box-shadow: 0 12px 35px rgba(0,0,0,0.5);
}

/* ===== TITLE ===== */
.title p {
  font-size: clamp(16px, 5vw, 22px);
  font-weight: bold;
  letter-spacing: 2px;
  color: #f5d7a1;
  text-shadow: 2px 2px 6px #000;
}

/* ===== RADIO BUTTONS ===== */
.radioBeat,
.radioGoc {
  margin: 10px;
  transform: scale(1.2);
  accent-color: #f5d7a1;
}

.labelBeat,
.labelGoc {
  margin-right: 15px;
  font-weight: bold;
  color: #f5d7a1;
}

/* ===== SELECT ===== */
.selectMeasure,
.selectSpeed {
  max-width: 220px;
  margin: 12px auto;
  border-radius: 14px;
  font-weight: bold;
}

/* Vuetify input border */
.v-field {
  border: 2px solid #5a2d2d !important;
  border-radius: 14px !important;
}

/* ===== BUTTONS ===== */
.start {
  background: linear-gradient(145deg, #3c7a52, #244a33);
  color: #fff;
  border-radius: 14px;
  padding: 7px 25px;
  margin: 10px;
  font-weight: bold;
  box-shadow: 0 5px 12px rgba(0,0,0,0.4);
  transition: all 0.2s ease;
}

.start:hover {
  transform: scale(1.05);
}

/* STOP dugme */
.stop {
  background: linear-gradient(145deg, #a13a3a, #6b2323);
  color: #fff;
  border-radius: 14px;
  padding: 7px 25px;
  margin: 10px;
  font-weight: bold;
  box-shadow: 0 5px 12px rgba(0,0,0,0.4);
  transition: all 0.2s ease;
}

.stop:hover {
  transform: scale(1.05);
}

/* ===== DIVIDER ===== */
.line {
  border-color: #f5d7a1 !important;
  opacity: 0.6;
}

</style>
